<template lang="pug">
.search-n-filter
  div
    slot
  div
    a.chip(@click="scrollToTop") To Top

</template>
<script>
export default {
  data () {
    return {
      selected: '',
      selectedCat: ''
    }
  },
  methods: {
    scrollToTop () {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop)
          window.scrollTo(0, c - c / 8)
        }
      }
      scrollToTop()
    }
  }
}
</script>

<style lang="stylus">

vivid_burgundy = #941c2f
rich_black = #03191e
dark_gunmetal = #202c39
dark_jungle_green = #151d25

.search-n-filter{
  display: flex;
  justify-content: space-between;
  left: 0;
  height: 45px;
  background-color: #202c39;
  overflow-x: scroll;
  position: fixed;
  bottom: 0;
  height: 50px;
  width: 100vw;
  align-items: center;
  z-index: 99;
  border-top: 3px solid dark_jungle_green;
  p{
    margin-left: 15px;
  }
  input{
    display: block;
    width: 300px;
    background-color: #333;
    color: #fff !important;
    height: 40px;
    border: none;
    margin: 0px;
    padding: 0px 0px 0px 5px;
    border-radius: 3px;
  }
  div{
    display: flex;
    align-items: center;
  }
  select{
    display: block;
    width: 250px;
    padding: 5px;
    height: 40px;
    margin-left: 15px;
  }
}
</style>
